import { render, staticRenderFns } from "./UserAnchorStat.vue?vue&type=template&id=660899dc&"
import script from "./UserAnchorStat.vue?vue&type=script&lang=js&"
export * from "./UserAnchorStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports